var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKissingCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5919 27.129C30.5932 32.1939 25.5745 35.5482 19.699 35.5482C14.6338 35.5482 9.00123 32.2995 7.00257 27.2346L6.93246 27.0609C6.29829 25.4721 6.40062 23.5276 6.40062 21.7095L8.43779 3.72554L14.1201 9.32548C15.7437 8.63232 17.5295 8.24837 19.4036 8.24837H19.9944C21.8685 8.24837 23.6542 8.63232 25.2779 9.32548L31.5158 3.16998L33.5837 21.9899C33.5837 23.8079 33.2347 25.5437 32.6 27.1324",
    fill: "#F4AA41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.699 35.5482C25.5928 35.7385 31.0068 32.2127 33.0055 27.1478L33.0671 27.0194C33.7013 25.4307 33.5993 23.188 33.5993 21.37L31.5158 3.16998",
    fill: "#E27022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4446 30.0889L29.2446 27.2",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1334 32.9778L26.9333 30.0889",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38436 26.6843C6.7637 25.1479 6.42236 23.4693 6.42236 21.7111L8.44459 3.51111L14.5445 9.46383C16.1323 8.7935 17.8786 8.42222 19.7113 8.42222H20.289C22.1217 8.42222 23.868 8.7935 25.4557 9.46383L31.5557 3.51116L33.5779 21.7112C33.5779 23.4693 33.2366 25.1479 32.6159 26.6843",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6809 32.9902C14.7206 34.2643 17.1299 35 19.7113 35H20.2891C22.8705 35 25.2809 34.2643 27.3195 32.9902",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55566 30.0889L10.7557 27.2",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8667 32.9778L13.0667 30.0889",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6891 21.6273C28.9557 19.3162 25.4891 19.3162 24.3335 21.6273",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31128 21.6273C11.0446 19.3162 14.5113 19.3162 15.6668 21.6273",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8042 26.4909C19.8042 26.4909 25.8852 28.3372 19.8042 29.7055C19.8042 29.7055 25.8464 31.432 19.8042 32.5438",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKissingCat);
export default __webpack_public_path__ + "static/media/kissingCat.92a046b1eac2c35aaf8d4018f495b7fc.svg";
export { ForwardRef as ReactComponent };